/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { createRoute } from '@gh/builder-shared';
import { HlpListBusinessService } from './resources/hlp-list-business.service';
import { HlpListComponent } from './components/hlp-list/hlp-list.component';

const routes: Routes = [createRoute({
  component: HlpListComponent,
  path: '',
  init: HlpListBusinessService,
  auth: {
    permission: 'EventLog.VIEW',
  },
})];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderHlpRoutingModule {
}
